import { render, staticRenderFns } from "./retrieve.vue?vue&type=template&id=67160815&scoped=true"
import script from "./retrieve.vue?vue&type=script&lang=js"
export * from "./retrieve.vue?vue&type=script&lang=js"
import style0 from "./retrieve.vue?vue&type=style&index=0&id=67160815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67160815",
  null
  
)

export default component.exports